
import 'slider-pro';


export const initSliderPro = () => {
	initSliderProFull();


};


const initSliderProFull =() => {
	if($('#sliderContent--main').length>0){

		$( '#sliderContent--main' ).sliderPro({
			width: '100%',
			//height: '500px',
			autoHeight: true,
			//aspectRatio: -1,
			//autoSlideSize: true,
			//imageScaleMode: 'exact',
			arrows: true,
			buttons: true,
			fade: false,
			autoplay: true,
		});

		/*
		var resizeTimer;

		$(window).on('resize', function() {

		  clearTimeout(resizeTimer);
		  resizeTimer = setTimeout(function() {
			  console.log("Resized");
			  console.log(homeSlider);
			  homeSlider.resize();
		    // Run code here, resizing has "stopped"

		  }, 250);

		});
		*/
	}

	if($('.sliderContent--scroll').length>0){

		$('.sliderContent--scroll').sliderPro({
			width: 300,
			height: 180,
			visibleSize: '100%',
			//forceSize: 'fullWidth',
			arrows: true,
			buttons: true,
			autoSlideSize: true
		});
	}

};
